module.exports = __webpack_public_path__ + "img/feliz.b6931d28.png";